export interface User {
  firstname: string;
  lastname: string;
  email: string;
}

export interface ProfileState {
  user?: User;
  session?: any;
  pages: Array<Page>;
}

export interface UserCredentials {
  login: string;
  password: string;
}

export enum Roles {
  SUPERVISOR = 'supervisor',
  COORDINATOR = 'coordinator',
  SUPPLIER = 'supplier',
  HR = 'HR',
  GUEST = 'guest',
  CONTROLLING = 'controlling',
  ACCOUNTANT = 'accountant',
  SIGNER = 'signer',
}

export interface Page {
  to: any;
  name: string;
  allowedRoles: Array<Roles>;
  isAllowed?: boolean;
  icon?: string;
}
